(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breed-hub"]) return;
  try {
    
  function initPetfleurBreedHub(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const cards = [...root.querySelectorAll('[data-breed-card]')];
    const search = root.querySelector('[data-breed-search]');
    const clear = root.querySelector('[data-breed-clear]');
    const size = root.querySelector('[data-breed-size]');
    const coat = root.querySelector('[data-breed-coat]');
    const status = root.querySelector('[data-breed-status]');
    const empty = root.querySelector('[data-breed-empty]');
    const letterButtons = [...root.querySelectorAll('[data-breed-letter]')];
    const topicButtons = [...root.querySelectorAll('[data-breed-topic]')];
    const resetButtons = [...root.querySelectorAll('[data-breed-reset]')];

    let letter = '';
    let topic = '';

    const normalize = (value = '') => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    const render = () => {
      const term = normalize(search?.value || '');
      const sizeValue = size?.value || '';
      const coatValue = coat?.value || '';
      let visible = 0;

      cards.forEach((card) => {
        const matchSearch = !term || normalize(card.dataset.name).includes(term);
        const matchSize = !sizeValue || card.dataset.size === sizeValue;
        const matchCoat = !coatValue || card.dataset.coat === coatValue;
        const matchLetter = !letter || card.dataset.letter === letter;
        const matchTopic = !topic || (card.dataset.topics || '').split(' ').includes(topic);
        const show = matchSearch && matchSize && matchCoat && matchLetter && matchTopic;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (clear) clear.hidden = !term;
      if (empty) empty.hidden = visible !== 0;
      if (status) status.textContent = visible === 1 ? '1 guia encontrado.' : `${visible} guias encontrados.`;

      letterButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.breedLetter === letter));
      topicButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.breedTopic === topic));
    };

    const reset = () => {
      if (search) search.value = '';
      if (size) size.value = '';
      if (coat) coat.value = '';
      letter = '';
      topic = '';
      render();
    };

    search?.addEventListener('input', render);
    clear?.addEventListener('click', () => { search.value = ''; search.focus(); render(); });
    size?.addEventListener('change', render);
    coat?.addEventListener('change', render);

    letterButtons.forEach((button) => button.addEventListener('click', () => {
      letter = letter === button.dataset.breedLetter ? '' : button.dataset.breedLetter;
      render();
    }));

    topicButtons.forEach((button) => button.addEventListener('click', () => {
      topic = topic === button.dataset.breedTopic ? '' : button.dataset.breedTopic;
      render();
    }));

    resetButtons.forEach((button) => button.addEventListener('click', reset));
    render();
  }

  document.querySelectorAll('[data-breed-hub]').forEach(initPetfleurBreedHub);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-breed-hub]').forEach(initPetfleurBreedHub);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function initPetfleurRecommendations(root) {
    root.querySelectorAll('[data-product-recommendations]').forEach((element) => {
      if (element.dataset.recommendationsInitialized === 'true') return;
      element.dataset.recommendationsInitialized = 'true';

      const load = () => {
        fetch(element.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations unavailable');
            return response.text();
          })
          .then((html) => {
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const content = documentFragment.querySelector('[data-product-recommendations]');
            if (content && content.querySelector('.petfleur-related__grid')) {
              element.innerHTML = content.innerHTML;
            } else if (!element.querySelector('.petfleur-related__editor-note')) {
              element.hidden = true;
            }
          })
          .catch(() => {
            if (!element.querySelector('.petfleur-related__editor-note')) element.hidden = true;
          });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        }, { rootMargin: '200px' });
        observer.observe(element);
      } else {
        load();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPetfleurRecommendations(document));
  } else {
    initPetfleurRecommendations(document);
  }
  document.addEventListener('shopify:section:load', (event) => initPetfleurRecommendations(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initPetfleurProduct(section) {
    if (section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';

    const rail = section.querySelector('[data-gallery-rail]');
    const thumbnails = [...section.querySelectorAll('[data-media-target]')];
    const activateMedia = (media) => {
      if (!section.classList.contains('petfleur-product--limpa-patas') || !media) return;
      const template = media.querySelector('[data-deferred-video]');
      if (template) {
        media.appendChild(template.content.cloneNode(true));
        media.querySelector('[data-video-poster]')?.remove();
        template.remove();
      }
      rail?.querySelectorAll('video').forEach((video) => {
        if (!media.contains(video)) video.pause();
      });
    };
    const showMedia = (id) => {
      if (!rail || !id) return;
      const media = [...rail.querySelectorAll('[data-media-id]')].find((item) => item.dataset.mediaId === id);
      if (!media) return;
      activateMedia(media);
      rail.scrollTo({ left: media.offsetLeft - rail.firstElementChild.offsetLeft, behavior: 'smooth' });
      thumbnails.forEach((button) => {
        const active = button.dataset.mediaTarget === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    thumbnails.forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    if (section.dataset.initialMediaId) showMedia(section.dataset.initialMediaId);

    if (rail && thumbnails.length > 0) {
      let scrollFrame;
      rail.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const current = [...rail.querySelectorAll('[data-media-id]')].reduce((closest, item) => {
            return Math.abs(item.offsetLeft - rail.firstElementChild.offsetLeft - rail.scrollLeft) <
              Math.abs(closest.offsetLeft - rail.firstElementChild.offsetLeft - rail.scrollLeft) ? item : closest;
          });
          activateMedia(current);
          thumbnails.forEach((button) => {
            const active = button.dataset.mediaTarget === current.dataset.mediaId;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        });
      }, { passive: true });
    }

    const variantSelect = section.querySelector('[data-variant-select]');
    if (!variantSelect) return;
    variantSelect.addEventListener('change', () => {
      const variant = variantSelect.selectedOptions[0];
      const onSale = variant.dataset.onSale === 'true';
      const available = variant.dataset.available === 'true';
      const compare = section.querySelector('[data-variant-compare]');
      const sale = section.querySelector('[data-variant-sale]');
      const availability = section.querySelector('[data-variant-availability]');
      const addButton = section.querySelector('.petfleur-product__add');

      section.querySelector('[data-variant-price]').textContent = variant.dataset.price;
      compare.textContent = variant.dataset.compare;
      compare.hidden = !onSale;
      sale.hidden = !onSale;
      availability.textContent = available ? 'Disponível para compra' : 'Indisponível no momento';
      availability.classList.toggle('is-unavailable', !available);
      addButton.disabled = !available;
      addButton.textContent = available ? 'Adicionar ao carrinho' : 'Produto indisponível';
      showMedia(variant.dataset.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.history.replaceState({}, '', url);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-product-section]').forEach(initPetfleurProduct);
    });
  } else {
    document.querySelectorAll('[data-product-section]').forEach(initPetfleurProduct);
  }
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-section]').forEach(initPetfleurProduct);
  });

  } catch(e) { console.error(e); }
})();
})();
